
import { defineComponent, ref, PropType } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios';

import type { FormData } from '../types'

type Props = {
  inquiry: FormData
}

export default defineComponent({
  props: {
    inquiry: {
      type: Object as PropType<FormData>,
      default: () => ({}),
    },
  },

  setup(props: Props) {
    const router = useRouter();

    const isErrorOccurred = ref<boolean>(false);
    const isInvokingApi = ref<boolean>(false)

    const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;

    const onSubmit = async () => {
      isInvokingApi.value = true;
      try {
        await axios
          .post(apiEndpoint, {...props.inquiry})
          router.push({path: "/thanks"});
      } catch (err) {
        isErrorOccurred.value = true;
          console.error(err.stack);
      } finally {
        isInvokingApi.value = false;
      }
    }

    return {
      onSubmit,
      isErrorOccurred,
      isInvokingApi,
    };
  }
})
